import React, { useCallback } from 'react';
import { QuerySuggestion } from '../../@types/QuerySuggestion';

interface SuggestionItemProps {
  suggestion: QuerySuggestion;
  onSelectSuggestion: (suggestion: QuerySuggestion) => void;
  active: boolean;
}

const SuggestionItem = ({ suggestion, onSelectSuggestion, active }: SuggestionItemProps) => {
  const onClick = useCallback(() => onSelectSuggestion(suggestion), [suggestion]);
  return (
    <li className="search__foldout-item" role="option" aria-selected={active}>
      <button
        className={`search__foldout-btn${
          active ? ' search__foldout-btn search__foldout-btn--is-active' : ''
        }`}
        onClick={onClick}
        tabIndex={-1}
      >
        <span className="search__foldout-btn-label theme theme__font--bold">
          {suggestion.label}
        </span>
        <span className="search__foldout-btn-info">{suggestion.term_count}</span>
      </button>
    </li>
  );
};

export default SuggestionItem;
